import { useEffect, useRef } from "react";

/**
 * 모달 포커스(P3-S6 접근성 — WCAG 2.4.3 · 2.1.2) — 열리면 첫 대상(ref)으로 포커스를 옮기고,
 * 열려 있는 동안 포커스가 대화 상자 밖으로 나가면 되돌리며(aria-modal), 닫히면 연 버튼으로 돌려준다.
 * ref 는 대화 상자 안의 요소(보통 닫기 · 취소 버튼)에 붙인다.
 */
export function useModalFocus<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  useEffect(() => {
    const opener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    ref.current?.focus();
    const keep = (e: FocusEvent) => {
      const dlg = ref.current?.closest("[role='dialog'], [role='alertdialog']");
      if (dlg && e.target instanceof Node && !dlg.contains(e.target)) ref.current?.focus();
    };
    document.addEventListener("focusin", keep);
    return () => {
      document.removeEventListener("focusin", keep);
      if (opener?.isConnected) opener.focus();
    };
  }, []);
  return ref;
}
